import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type ContactRelationshipsFetchFailedAction = {
	type: 'CONTACT_RELATIONSHIPS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): ContactRelationshipsFetchFailedAction => ({
	type: 'CONTACT_RELATIONSHIPS_FETCH_FAILED',
	payload,
});
